import styled from 'styled-components';

export const ContContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: #ffffff;
  z-index: 2;
`;
